import cls from "./customInnerPage.module.scss";
import React, { FC, MouseEvent, useState } from "react"; // Import useState

interface IProps {
    boxAboutDetailsClass: {
        className: string;
        display: "none" | "block"
    }
    isSelectedDetailSectionClass: {
        first: string;
        second: string,
        content: React.JSX.Element
    },
    productDescOptionName: string;
    Details_INTL: string;
    selectTab: (e: MouseEvent<HTMLDivElement>) => void;
    showDescription: boolean
    showDetailsInFront: boolean
}

const CustomDetailTabButtons: FC<IProps> = (
    {
        boxAboutDetailsClass,
        isSelectedDetailSectionClass,
        productDescOptionName,
        Details_INTL,
        selectTab,
        showDescription,
        showDetailsInFront
    }
) => {

    const hideDescription = {
        "true": <div className={`${isSelectedDetailSectionClass.first} `}
                     onClick={selectTab}>
            <div className={`${cls["product-inner-description-title"]}`}>
                {productDescOptionName}
            </div>
        </div>,
        "false": <></>
    }

    const hideDetails = {
        "true": <div style={{display: boxAboutDetailsClass?.display}}
                     className={`${isSelectedDetailSectionClass.second}`}
                     id="detail" onClick={selectTab}>
                    <div className={cls["product-inner-description-title"]} id="detail">
                        {Details_INTL}
                    </div>
                </div>,
        "false": <></>
    }

    return (
        <div className={`${cls["tab_buttons"]} ${cls[boxAboutDetailsClass?.className]} `}>
            {hideDescription[`${showDescription}`]}
            {hideDetails[`${showDetailsInFront}`]}
        </div>
    );
};

export default CustomDetailTabButtons;